import adminTable from "@store/adminTable/reducers";

import { subject } from "@Modules/Subject/configs/constants";

export default adminTable(subject);
